import { formatPrice } from "../data/api";

// Renders price like: $0.0₅641 (subscript zero count)
export const PriceDisplay = ({ price, className = "" }) => {
  const formatted = formatPrice(price);

  if (typeof formatted === "string") {
    return <span className={className}>{formatted}</span>;
  }

  // Subscript zero format: $0.0₅641
  return (
    <span className={className}>
      $0.0
      <sub className="text-[0.65em] text-muted-foreground opacity-70">
        {formatted.zeros}
      </sub>
      {formatted.digits}
    </span>
  );
};
